<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="450"
    height="380"
    id="milestone-jamstack1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-100 0 400 300"
    role="presentation"
    aria-labelledby="jamstack1conf"
  >
    <title id="jamstack1conf">First Jamstack Conference</title>
    <defs>
      <clipPath id="jamstack-clip" transform="translate(-134.9 -35)">
        <rect
          id="clip-jamstackconf1"
          class="cls-1"
          x="240.2"
          y="-39.1"
          width="88.1"
          height="337.03"
          transform="matrix(0.49, -0.87, 0.87, 0.49, 32.85, 314.73)"
        />
      </clipPath>
    </defs>
    <image href="conf-bk.png" x="-75" height="380" width="330" />
    <g id="ConferenceJamstack1">
      <g id="ScenarioJamstack1">
        <g id="Graph_2" data-name="Graph 2">
          <polygon
            class="cls-2"
            points="132.5 172.2 129.2 196.2 129.4 196.2 132.7 172.3 132.5 172.2"
          />
          <polygon
            class="cls-2"
            points="116.2 162.7 112.8 186.8 113 186.7 116.3 162.8 116.2 162.7"
          />
          <polygon class="cls-2" points="137.2 171.8 139.8 190.2 140 190 137.5 171.7 137.2 171.8" />
          <path
            class="cls-3"
            d="M273,206.3l.7-.4.2-.3v-2.8h0v-.2h-.1l-1.6-1V175.8h-.1l-18.9-11h-.3l-.9.5h-.2v27.3l-3,1.6h-.1v1.1l.2.3,1,.6-3.5,25.1.2.4.9.5h.4l.9-.6.2-.2,3.4-23.8,2.5,1.4,2.3,16.1a.2.2,0,0,0,.2.2l.9.6h.4l.9-.5a.5.5,0,0,0,.2-.4l-2-14.4,8.8,5.1-3.5,25.1a.8.8,0,0,0,.2.4l.9.5h.4l.9-.6.2-.2,3.4-23.7,1.1.6h.4l1-.6,2.4,17.5.2.2.9.6h.4l.9-.5a.5.5,0,0,0,.2-.4Zm-8.9,24.9,3.3-24h.2l-3.4,23.9Zm-15-35.5v-.3l20.1,11.5v.5Zm9.1,19.9-2.1-15,.3.2,2,14.7Zm-10.5,6.2,3.3-24.1h.2l-3.4,23.9Zm4-27.4,19.2,11.1-1.4.9-20.1-11.5,2.1-1.2v.4Zm20.5,9.2v.7H272v-.7Zm-.5,1.3h0Zm-.4-3.2v2.6h-.2V176.7h.2Zm-15.1-33.3,14.3,8.3v27.7l-18.2-10.5V166.2ZM272.5,203l-.5-.3v-.4l.8.5Zm-1.7-26.9-18.2-10.5h.2L271,176Zm-.9,31.3V207l2.9-1.7h.1v-1.5l.3-.2v2Zm4.8,17.8-2.5-18.4h.2l2.6,18.4Z"
            transform="translate(-134.9 -35)"
          />
          <polygon
            class="cls-2"
            points="121.2 165.6 123.3 180.6 123.5 180.5 121.5 165.8 121.2 165.6"
          />
          <path
            class="cls-2"
            d="M252.2,193.9l18.2,10.5V176.7l-14.3-8.3-3.9-2.3v27.8Zm1.1-25.9h.3l15.6,9.1.2.3V202l-.2.3h-.4l-15.6-9.1-.2-.3V168.4Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M253.8,192.6l14.9,8.7V177.6l-14.9-8.7v23.7Zm13.6,2.1h0a2.5,2.5,0,0,1-1.1,2.4,1.5,1.5,0,0,1-.9.2,1.9,1.9,0,0,1-1.2-.4h0a6.9,6.9,0,0,1-2.9-5.5,2.5,2.5,0,0,1,1.1-2.4,2.2,2.2,0,0,1,2.2,0l.2.2a7.2,7.2,0,0,1,2.6,5.5Zm0-9.9h0a2.7,2.7,0,0,1-1.1,2.5l-.8.2a2.4,2.4,0,0,1-1.3-.4h0a7,7,0,0,1-2.9-5.5,2.7,2.7,0,0,1,1.1-2.5,1.9,1.9,0,0,1,1.9.1h.2a7,7,0,0,1,2.9,5.6Zm-12-13.8.2-.3h.3l11.1,6.4.2.3v1l-.2.3h-.4l-11.1-6.4-.2-.3v-1Zm.2,4.2a2,2,0,0,1,2.1.1h0a7,7,0,0,1,2.9,5.5,2.7,2.7,0,0,1-1.1,2.5,1.5,1.5,0,0,1-.9.2,1.9,1.9,0,0,1-1.2-.4h0a7,7,0,0,1-2.9-5.5A2.7,2.7,0,0,1,255.6,175.2Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M253.1,192.8l.2.3,15.6,9.1h.4l.2-.3V177.3c0-.1-.1-.2-.2-.3l-15.6-9.1h-.3l-.2.3v24.6Zm15.7-15.2v23.7l-14.9-8.7V168.9Z"
            transform="translate(-134.9 -35)"
          />
          <polygon
            class="cls-2"
            points="136.2 169.4 136.4 169.3 136.4 167.9 136.4 166.7 136.4 141.6 136.2 141.7 136.2 169.4"
          />
          <polygon
            class="cls-2"
            points="117.7 130.5 135.9 141.1 136.1 141 117.9 130.4 117.7 130.5"
          />
          <polygon
            class="cls-2"
            points="137.1 167.7 137.6 168 137.9 167.8 137.1 167.3 137.1 167.7"
          />
          <polygon class="cls-2" points="136.8 170.1 137 170 136.8 169.9 136.6 170 136.8 170.1" />
          <polygon
            class="cls-2"
            points="134.3 172.4 134.3 172.2 134.3 172 114.2 160.4 114.2 160.7 134.3 172.4"
          />
          <path
            class="cls-2"
            d="M273.2,205.4v-2l-.3.2v1.5h-.1l-2.9,1.7v.4Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M249.4,194.8l20.1,11.5,1.4-.9-19.2-11.1-.2-.3v-.4Z"
            transform="translate(-134.9 -35)"
          />
          <polygon
            class="cls-2"
            points="137.1 169.2 137.3 169.3 137.3 168.6 137.1 168.5 137.1 169.2"
          />
          <path
            class="cls-2"
            d="M257.2,175.9l-.7-.2H256a2.1,2.1,0,0,0-.8,1.9,6.7,6.7,0,0,0,2,4.5Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M257.4,183.3h0a3.3,3.3,0,0,0,1.3.4l.9-.2a2.7,2.7,0,0,0,1.1-2.5,7,7,0,0,0-2.9-5.5h0a2,2,0,0,0-2.1-.1,2.7,2.7,0,0,0-1.1,2.5A6.8,6.8,0,0,0,257.4,183.3Zm-1.4-7.5h.5l.7.2v6.4a6.3,6.3,0,0,1-2-4.5A2.2,2.2,0,0,1,256,175.8Zm3.2,7a1.9,1.9,0,0,1-1.3,0v-6.4a6.3,6.3,0,0,1,2,4.5A1.9,1.9,0,0,1,259.2,182.8Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M257.9,176.3v6.4a1.2,1.2,0,0,0,1.3,0,2.1,2.1,0,0,0,.8-1.9A6.8,6.8,0,0,0,257.9,176.3Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M264.1,193.4c-.1,0-.1-.1-.1-.2l-2-1.1a6.3,6.3,0,0,0,2.5,4.3,1.6,1.6,0,0,0,1.5.1,2,2,0,0,0,.7-1.6Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M267.4,194.6a6.8,6.8,0,0,0-2.8-5.4l-.2-.2a2.2,2.2,0,0,0-2.2,0,2.7,2.7,0,0,0-1.1,2.4,6.9,6.9,0,0,0,2.9,5.5h0l1.2.4.9-.2a2.7,2.7,0,0,0,1.1-2.4Zm-1.5,1.9a1.6,1.6,0,0,1-1.5-.1,6.3,6.3,0,0,1-2.5-4.3l2,1.1c0,.1.1.1.1.2l2.6,1.5A1.7,1.7,0,0,1,265.9,196.5Zm-3.2-6.9a1.5,1.5,0,0,1,1.3,0v2.8l-2-1.1A2.1,2.1,0,0,1,262.7,189.6Zm3.9,4.5-2.1-1.2v-2.8A6,6,0,0,1,266.6,194.1Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M263.4,182.3l.6.3v-2.8c-.5-.2-.9-.3-1.2-.1a2.1,2.1,0,0,0-.8,1.7Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M264.6,180.2v2.7l1.6,1,.4.2A5.9,5.9,0,0,0,264.6,180.2Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M263.9,183.4l-2-1.2a7,7,0,0,0,2,3.9Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M266.7,185l-2-1.2v2.9a1.3,1.3,0,0,0,1.2.1A2.8,2.8,0,0,0,266.7,185Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M267.4,184.8a6.5,6.5,0,0,0-2.9-5.5h-.2a2.1,2.1,0,0,0-1.9-.1,2.7,2.7,0,0,0-1.1,2.5,7,7,0,0,0,2.9,5.5h0a2.2,2.2,0,0,0,1.3.4l.8-.2a3.3,3.3,0,0,0,1.1-2.6Zm-1.5,1.9a1.3,1.3,0,0,1-1.2-.1v-2.9l2,1.2A2.3,2.3,0,0,1,265.9,186.7Zm-3.2-7a1.1,1.1,0,0,1,1.2.1v2.8l-.6-.3-1.5-.9A2.5,2.5,0,0,1,262.7,179.7Zm3.6,4.2-1.6-1v-2.7a5.9,5.9,0,0,1,2,3.9Zm-2.4-.5v2.7a6.7,6.7,0,0,1-2-3.9Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M263.9,192.4v-2.8a1.5,1.5,0,0,0-1.3,0,2.1,2.1,0,0,0-.7,1.7Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M264.6,190.1v2.8l2.1,1.2A6,6,0,0,0,264.6,190.1Z"
            transform="translate(-134.9 -35)"
          />
          <polygon
            class="cls-2"
            points="131.6 142.7 121.2 136.6 121.2 136.8 131.6 142.8 131.6 142.7"
          />
          <path
            class="cls-3"
            d="M266.7,178.7h.4l.2-.3v-1l-.2-.3L256,170.7h-.3l-.2.3v1l.2.3Zm-10.6-7.1,10.4,6v.2l-10.4-6Z"
            transform="translate(-134.9 -35)"
          />
        </g>
        <g id="Guy_1" data-name="Guy 1">
          <g id="man-arm">
            <g id="Vector_1378" data-name="Vector 1378">
              <path
                class="cls-4"
                d="M270.2,183.7c-.1-1.2-.8-1.2-.9-.2s-.1,2.3-.1,2.3-1.3.6-1.4,1.4a1.4,1.4,0,0,0-.3,1.3c.2.7,1,1,1.5,1.4a3.2,3.2,0,0,1,1,1.5l1.9-1-1.7-4.3C270.4,186,270.3,184.9,270.2,183.7Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M270.1,191.8H270a.2.2,0,0,1-.2-.2,2.9,2.9,0,0,0-.9-1.3l-.4-.2a2.6,2.6,0,0,1-1.3-1.4,1.5,1.5,0,0,1,.3-1.6,2.3,2.3,0,0,1,.5-1.1,1.3,1.3,0,0,1,.9-.5c0-.5-.1-1.5-.1-2s.3-1,.6-1,.9.1,1,1.2h0a21.3,21.3,0,0,0,.3,2.4c.1.3,1.1,2.7,1.6,4.2s0,.4-.2.4l-1.9,1Zm-1.1-5.6-.5.2a1.9,1.9,0,0,0-.4.9v.2a1,1,0,0,0-.2,1c.1.4.6.7,1,1l.4.3a3.1,3.1,0,0,1,1,1.3l1.3-.7a31.9,31.9,0,0,1-1.6-4.2V186c0-.2-.1-1.4-.1-2.2h0c0-.3-.1-.8-.4-.6s-.2.2-.1.5a20.8,20.8,0,0,0,.2,2.2v.3c0,.1-.2.1-.3.1A.1.1,0,0,0,269,186.2Z"
                transform="translate(-134.9 -35)"
              />
            </g>
            <g id="Vector_1379" data-name="Vector 1379">
              <path
                class="cls-2"
                d="M271.7,189.1a3.2,3.2,0,0,1-.8.9,2.5,2.5,0,0,1-1.5.7s1.3,5.8,2,6.6,2.4,2.4,3.2,1.5-.5-3.3-1-4.8S271.7,189.1,271.7,189.1Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M274,199.5c-.9,0-2.1-1-2.9-1.9s-2-6.2-2.1-6.8a.4.4,0,0,1,.1-.3h.3a2.2,2.2,0,0,0,1.3-.6,2.7,2.7,0,0,0,.7-.8l.3-.2h.3c.1.1,1.5,3.5,2,5s2,4.2.9,5.2a1.3,1.3,0,0,1-.9.4Zm-4.2-8.5c.5,2.2,1.4,5.6,1.9,6.1s1.9,1.7,2.4,1.7h.3c.6-.6-.5-2.8-1.1-4.5s-.9-3.5-1.6-4.4l-.5.6Z"
                transform="translate(-134.9 -35)"
              />
            </g>
            <ellipse
              class="cls-2"
              cx="273.6"
              cy="196.2"
              rx="1.7"
              ry="2.8"
              transform="translate(-188.9 83.6) rotate(-22.3)"
            />
          </g>
          <g>
            <path
              class="cls-2"
              d="M279.4,184.5l-.3-.5c-.5.1-1.9.6-3.1,3.4s-1.8,4.8-2.3,6.4a4.4,4.4,0,0,1,1.2,1.9c.4,1.3.4,2.5-.1,3C276.9,197.7,278.7,189.7,279.4,184.5Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M280.1,184.2l-.5-.8-.3-.2c-.1,0-2.3-.1-4,3.8s-1.8,4.9-2.3,6.4l.4.2.3.2c.5-1.6,1.3-4,2.3-6.4s2.6-3.3,3.1-3.4l.3.5c-.7,5.2-2.5,13.2-4.6,14.2l-.2.2H274a1.3,1.3,0,0,1-.6-.5c.2.6.5,1.1.9,1.1,3.7,0,5.6-13.5,5.9-15A.3.3,0,0,1,280.1,184.2Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1363" data-name="Vector 1363">
            <path
              class="cls-2"
              d="M273.1,234.2c-.9.9-1.2,1.1-2,2s-.1.9.8.9a12.5,12.5,0,0,0,6.6-2.3,1.6,1.6,0,0,0,.8-1v-1.5l-4.5.2A22.5,22.5,0,0,1,273.1,234.2Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M271.9,237.4c-.7,0-1.2-.2-1.3-.6s-.1-.5.3-.9l1-.9,1-1,1.7-1.7h.2l4.5-.2h.3a.4.4,0,0,1,.1.3v1.5a1.9,1.9,0,0,1-1,1.3,25.7,25.7,0,0,1-2.9,1.5A20.1,20.1,0,0,1,271.9,237.4Zm3.1-4.6-1.6,1.6h0l-1.1,1-1,.9h-.1a1,1,0,0,0,.7.2,13.1,13.1,0,0,0,3.6-.8,22.3,22.3,0,0,0,2.7-1.4,1.3,1.3,0,0,0,.7-.8v-1Zm-1.9,1.4Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1364" data-name="Vector 1364">
            <path
              class="cls-2"
              d="M286.5,234.3s-.1,1.5-.3,3.4.1,3.6.8,3.8,2.2.2,3.2-2.4a9.3,9.3,0,0,0,.3-5.2Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M287.5,241.9h-.6c-.9-.3-1.1-2.4-1-4.1s.3-3.4.3-3.4a.3.3,0,0,1,.3-.3l4-.5c.2,0,.3.1.4.3a10.7,10.7,0,0,1-.4,5.4,3.8,3.8,0,0,1-2,2.5A2,2,0,0,1,287.5,241.9Zm-.7-7.3a27.4,27.4,0,0,1-.3,3.1c-.2,2,.2,3.3.5,3.4a1.5,1.5,0,0,0,1.1-.1,3.4,3.4,0,0,0,1.7-2.1,10.4,10.4,0,0,0,.4-4.7Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1365" data-name="Vector 1365">
            <path
              class="cls-2"
              d="M289.1,220.7c-.2-4.3-.9-10-.7-12.4a11.1,11.1,0,0,0-2.7-8.3c.2-1.8-8.2.7-8.2.7s-1.8,9.8-2.6,15-.5,16.4-.5,16.4.1,1.3,2.3,1.3a5,5,0,0,0,3.1-1.4V219.7l2-9.7s.3,9,1.5,11.6c2.2,4.7,2.2,13.2,2.2,13.2s2.9,1,4.8.1,1.5-2.1,1.5-2.1A38.9,38.9,0,0,0,289.1,220.7Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M288.5,235.6a10.7,10.7,0,0,1-2.9-.5c-.1,0-.2-.2-.2-.3s0-8.4-2.2-13c-.8-1.8-1.2-6.2-1.4-9.1l-1.4,7v12.2c0,.1,0,.2-.1.2a5.2,5.2,0,0,1-3.3,1.5c-2.4,0-2.6-1.5-2.6-1.6s-.4-10.7.5-16.5,2.6-14.9,2.6-15l.2-.3c1.2-.4,7.2-2.1,8.4-1a.5.5,0,0,1,.3.5,11,11,0,0,1,2.6,8.5,73,73,0,0,0,.3,7.3c.1,1.7.3,3.4.4,5a38.5,38.5,0,0,1,2.9,12.1c.1.3.2,1.5-1.7,2.5A5,5,0,0,1,288.5,235.6Zm-2.4-1.1c.7.2,2.8.8,4.3,0s1.4-1.6,1.4-1.7h0a38.2,38.2,0,0,0-2.9-11.9h0c-.1-1.6-.2-3.3-.4-5a52.7,52.7,0,0,1-.3-7.4,10.8,10.8,0,0,0-2.5-8,.4.4,0,0,1-.1-.3h0c-.7-.6-4.7.3-7.5,1.1-.3,1.5-1.8,10.1-2.5,14.8s-.5,16.2-.5,16.3.2.9,2,.9a4.2,4.2,0,0,0,2.7-1.2V219.7l2-9.8c0-.2.2-.3.4-.3a.3.3,0,0,1,.3.3c0,.1.4,9,1.5,11.5C285.8,225.8,286,233.1,286.1,234.5Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1366" data-name="Vector 1366">
            <path
              class="cls-2"
              d="M287.7,199.3c.5-3.7,1.2-9.7,1-10.7s-4-3.4-4-3.4-2.7-2-5.4-1a10,10,0,0,0-3.3,5.7c-.1,1.7.3,7.3.3,10.9,0,2-.8,7.8-.8,7.8a22.6,22.6,0,0,0,2.6,1.5,19.4,19.4,0,0,1,.6-3.8s.1,2.6.1,4a9.5,9.5,0,0,0,3,.4c2.7,0,6.8-1.9,6.8-1.9S287.3,201.8,287.7,199.3Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M281.9,211.1a10.1,10.1,0,0,1-3.1-.4c-.1,0-.2-.2-.2-.3v-.2c0,.1-.1.2-.2.3h-.3l-2.7-1.5c-.1-.1-.2-.2-.2-.3s.8-5.8.8-7.8-.1-4-.2-5.9a46.1,46.1,0,0,1-.1-5,10.3,10.3,0,0,1,3.4-6h.1a6.4,6.4,0,0,1,5.7,1c.3.1,3.9,1.8,4.1,3.7s-.6,7.5-1,10.8h0c-.3,2.4,1,9.4,1,9.5s0,.3-.2.4S284.7,211.1,281.9,211.1Zm-2.6-1a11.2,11.2,0,0,0,2.7.3,20.1,20.1,0,0,0,6.4-1.7c-.3-1.4-1.3-7.2-1-9.5.6-4.5,1.2-9.7,1-10.6s-2.8-2.7-3.8-3.1-2.6-1.9-5-1c-.3.3-2.8,2.5-3.1,5.5a44.4,44.4,0,0,0,.1,4.9c.1,2,.2,4.2.2,6s-.7,6.5-.8,7.6l1.9,1.1c.1-1.4.5-3.2.5-3.3s.2-.3.4-.3a.3.3,0,0,1,.3.3A26.9,26.9,0,0,1,279.3,210.1Zm8.4-10.8Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1367" data-name="Vector 1367">
            <path
              class="cls-2"
              d="M284.3,184.2l-3.6-.3a17.7,17.7,0,0,0-2.7,2.8,3.8,3.8,0,0,0-.8,1.5l.8.8-1.3.6s-.7,4.6.3,6.1a32.6,32.6,0,0,1,2,5.4,45.2,45.2,0,0,1,1.9-5c.6-1,2.7-3.8,2.7-3.8l-1-1.6,1.7-.6s2.4-3.1,2.2-4A3,3,0,0,0,284.3,184.2Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M279,201.5h0a.3.3,0,0,1-.3-.3,32.6,32.6,0,0,0-2-5.4c-1-1.6-.4-6.2-.3-6.4l.2-.3.8-.4-.5-.5a.4.4,0,0,1-.1-.3,6.4,6.4,0,0,1,.9-1.7,19.3,19.3,0,0,1,2.8-2.9h.2l3.6.3h0a3.4,3.4,0,0,1,2.5,2.3c.2,1.1-1.9,3.8-2.3,4.4s-.1.1-.2.1l-1.3.4.8,1.2a.3.3,0,0,1,0,.4s-2.2,2.8-2.7,3.7-1.8,4.9-1.9,5S279.2,201.5,279,201.5Zm-2-11.7c-.2,1.4-.5,4.6.3,5.7A30,30,0,0,1,279,200a27.5,27.5,0,0,1,1.6-4,37.4,37.4,0,0,1,2.6-3.6l-.9-1.4a.2.2,0,0,1,0-.3.2.2,0,0,1,.2-.2l1.6-.5c1.1-1.4,2.2-3.2,2.1-3.7a2.9,2.9,0,0,0-1.9-1.7l-3.5-.3a15.8,15.8,0,0,0-2.5,2.6l-.7,1.2.7.7a.4.4,0,0,1,.1.3l-.2.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1368" data-name="Vector 1368">
            <path
              class="cls-2"
              d="M279.1,187.1a29.4,29.4,0,0,0-1,4c-.3,1.9,1,8.2,1,8.2s.6-6.2,1.9-8a36.6,36.6,0,0,1,3.4-4S280.3,186.6,279.1,187.1Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M279,199.7a.3.3,0,0,1-.3-.3c-.1-.3-1.3-6.4-1-8.4a17.9,17.9,0,0,1,1.1-4.1.2.2,0,0,1,.2-.2c1.3-.5,5,.2,5.4.3l.3.2c0,.1,0,.3-.1.3s-1.9,2-3.4,4-1.8,7.7-1.8,7.8-.2.4-.4.4Zm.4-12.3a26.9,26.9,0,0,0-1,3.8,23.6,23.6,0,0,0,.6,6c.3-2,.9-4.8,1.7-5.9a25.6,25.6,0,0,1,3-3.6A11,11,0,0,0,279.4,187.4Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1369" data-name="Vector 1369">
            <path
              class="cls-2"
              d="M279.8,187.4l-.2,1.6a4.1,4.1,0,0,0-1.2,2.1,44,44,0,0,0,0,5.2l.6,2.9.3-2s.4-2.5.8-4.1a10.3,10.3,0,0,0,.1-1.4,9.2,9.2,0,0,0,.3-2.4l1-1.2-1-1.1Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M278.9,199.6a.3.3,0,0,1-.3-.3l-.6-2.9a47.7,47.7,0,0,1,0-5.4,4.4,4.4,0,0,1,1.2-2.2l.2-1.5c0-.1.1-.2.2-.3l.8-.3h.4l1,1.1a.4.4,0,0,1,0,.5l-1,1.1a11.1,11.1,0,0,1-.3,2.3,1.8,1.8,0,0,1-.1.6v.7c-.4,1.6-.8,4.1-.8,4.1l-.3,1.9c.1.4-.1.5-.3.5Zm1.2-11.9-.2,1.4c0,.1,0,.2-.1.2a3.8,3.8,0,0,0-1.1,1.9,44.2,44.2,0,0,0,0,5.2l.2.8c.1-.5.5-2.6.8-4v-.7a3.5,3.5,0,0,1,.1-.6h0a8.2,8.2,0,0,0,.3-2.3c0-.1,0-.2.1-.2l.8-1-.6-.7Zm-.5,1.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1370" data-name="Vector 1370">
            <path
              class="cls-2"
              d="M278.9,187.9l1.7-.7-.2-2.1C278.7,185.6,278.9,187.9,278.9,187.9Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M278.9,188.2h-.2l-.2-.3c0-.1-.2-2.5,1.7-3.2h.3l.2.3.2,2.1a.5.5,0,0,1-.2.4l-1.7.7Zm1.2-2.6a2.1,2.1,0,0,0-.8,1.7l1-.4Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1371" data-name="Vector 1371">
            <path
              class="cls-2"
              d="M282.7,186.5a16.4,16.4,0,0,1-2.1.7l.6,1.9a15.2,15.2,0,0,0,3-1.6s1.3-1.5.1-2.7S283.9,185.8,282.7,186.5Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M281.2,189.4h-.1a.2.2,0,0,1-.2-.2l-.6-1.9V187l.2-.2a7.9,7.9,0,0,0,2-.7,4,4,0,0,0,1.5-1.4c0-.1,0-.2.1-.2h.5a2.4,2.4,0,0,1-.1,3.2,17.6,17.6,0,0,1-3.1,1.7Zm-.1-2,.4,1.2a22.6,22.6,0,0,0,2.6-1.4,1.9,1.9,0,0,0,.4-1.8,5.1,5.1,0,0,1-1.5,1.4h0Zm1.6-.9Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1372" data-name="Vector 1372">
            <path
              class="cls-4"
              d="M286.4,210c-.2.2-.7,1.2-1.2,1.5s-.5.6-.1.7,1-.7,1.3-.7-.3,1.6-.3,2.5.5,2.3,1.6.9a7.7,7.7,0,0,0,1.5-3.9,6.2,6.2,0,0,1,.6-1.7l-2.5-.9A5.3,5.3,0,0,1,286.4,210Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M286.8,215.9h-.3c-.7-.2-.8-1.2-.8-1.8a6.8,6.8,0,0,1,.2-1.4c0-.2.1-.3.1-.5a1.1,1.1,0,0,1-1,.4,1.1,1.1,0,0,1-.5-.4c-.1-.3.1-.6.5-.9a3.9,3.9,0,0,0,.8-1l.3-.5a4.2,4.2,0,0,0,.8-1.4c0-.2.2-.3.4-.3h.1l2.5.9.2.2v.3a7,7,0,0,0-.5,1.6h0a7.6,7.6,0,0,1-1.6,4C287.5,215.7,287.2,215.9,286.8,215.9Zm-.5-4.7.4.2c.2.3.1.7-.1,1.4a5.9,5.9,0,0,0-.2,1.3c0,.6.2,1.1.4,1.1s.3,0,.6-.5a7.4,7.4,0,0,0,1.4-3.7h0a8.4,8.4,0,0,1,.4-1.4l-1.8-.7a4.6,4.6,0,0,1-.8,1.3h0l-.3.4a5.6,5.6,0,0,0-.5.8Zm.1-1.2Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1373" data-name="Vector 1373">
            <path
              class="cls-2"
              d="M287.9,187.2c-.8.5-1.4,2.9-1.4,5.4l.6,7.3-.6,9.1c.6.3,2.6,2,4.1,1.3s.8-8.6,1-10.5a31.9,31.9,0,0,0-.9-7.7C290,189.1,289.6,187.4,287.9,187.2Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M289.8,210.9a6.3,6.3,0,0,1-3.3-1.4l-.2-.2-.2-.3.6-9.1-.6-7.3c0-2.3.5-5.1,1.6-5.7h.2c1.9.2,2.4,1.9,3.1,4.9v.4a33.3,33.3,0,0,1,.9,7.8c-.1.8-.2,2.2-.3,3.8a50.8,50.8,0,0,1-.7,6.7l-.2.2Zm-3-2h0c.8.5,2.3,1.6,3.5,1.2a56.2,56.2,0,0,0,.7-6.4c.1-1.7.2-3.1.3-3.8a31.4,31.4,0,0,0-.9-7.5V192c-.7-2.9-1.1-4.2-2.3-4.4s-1.1,2.6-1.1,5l.6,7.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Group_193" data-name="Group 193">
            <g id="Vector_1374" data-name="Vector 1374">
              <path
                class="cls-2"
                d="M286.3,185.8l-1.2.9a10.8,10.8,0,0,0-2.8,2.4c-1.8,2-3.3,6.5-3.8,7.3-.3-1-.9-6.1-.5-8a11.7,11.7,0,0,1,1.7-3.7h-.3a8.4,8.4,0,0,0-1.7,3.8c-.6,2.4.6,8.4.6,8.6v.1s1.7-5.1,4-7.6a12.8,12.8,0,0,1,2.7-2.4l1.3-1a.2.2,0,0,0,0-.3C286.5,185.7,286.4,185.7,286.3,185.8Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M278.5,197.8h0c-.2,0-.3-.1-.3-.2v-.4c-.1-.2-1.2-6.2-.6-8.8a10.1,10.1,0,0,1,1.8-3.9c.1-.1.3-.2.4-.1h.3a.2.2,0,0,1,.2.2.4.4,0,0,1-.1.3,11.9,11.9,0,0,0-1.7,3.6,26.4,26.4,0,0,0,.3,6.8c.1-.1.1-.3.2-.4a24.3,24.3,0,0,1,3.3-6.1,9.9,9.9,0,0,1,2.9-2.5,4.8,4.8,0,0,0,1.1-.9h0c.1-.1.4-.2.5-.1l.3.3v.3l-.2.4-1,.8-.3.2a15,15,0,0,0-2.7,2.3c-2.2,2.4-3.9,7.4-3.9,7.5v.4Z"
                transform="translate(-134.9 -35)"
              />
            </g>
          </g>
          <g id="Vector_1375" data-name="Vector 1375">
            <path
              class="cls-2"
              d="M277.3,198.7l2.2,1.3.2-3.5-2.2-1.3Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M279.6,200.3h-.2l-2.2-1.3c-.1-.1-.2-.2-.2-.3l.2-3.6.2-.3a.2.2,0,0,1,.3,0l2.2,1.3.2.3-.2,3.5-.2.3A.1.1,0,0,1,279.6,200.3Zm-1.9-1.8,1.6.9.2-2.7-1.6-.9Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1376" data-name="Vector 1376">
            <path
              class="cls-2"
              d="M277.7,195.9l1.9,1v-.3l-1.9-1.1Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M279.6,197.3h-.2l-1.9-1-.2-.3v-.4l.2-.3c.1-.1.2-.1.4,0l1.9,1.1.2.3v.3l-.2.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1377" data-name="Vector 1377">
            <path
              class="cls-2"
              d="M278.2,198.9l1.2.7v-2.3l-1.1-.7Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M279.4,199.9h-.2l-1.2-.7-.2-.3.2-2.3.2-.3c.1-.1.2,0,.3,0l1.1.7c.1.1.2.2.2.3v2.3l-.2.3Zm-.9-1.2.5.3v-1.5l-.5-.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Group_5" data-name="Group 5">
            <g id="Group_194" data-name="Group 194">
              <g id="Vector_1380" data-name="Vector 1380">
                <path
                  class="cls-4"
                  d="M280.5,184.1l-.2,2.6a6.6,6.6,0,0,0,1.2,1.3,16.4,16.4,0,0,0,3.1-2.3l-.7-4Z"
                  transform="translate(-134.9 -35)"
                />
                <path
                  class="cls-3"
                  d="M281.5,188.3c-.1,0-.2,0-.2-.1a6.6,6.6,0,0,1-1.2-1.3c0-.1-.1-.1-.1-.2l.2-2.6v-.3l3.3-2.4h.3c.1,0,.2.1.2.3l.7,4a.4.4,0,0,1-.1.3,13.2,13.2,0,0,1-3.2,2.4Zm-.9-1.7.9,1a16.4,16.4,0,0,0,2.6-2l-.6-3.2-2.8,2Z"
                  transform="translate(-134.9 -35)"
                />
              </g>
              <g id="Vector_1381" data-name="Vector 1381">
                <path
                  class="cls-4"
                  d="M278.7,177.6c-1.9,2.8-.1,7.4,1.5,7.1a6.6,6.6,0,0,0,4-2.5,5.2,5.2,0,0,0,.1-5A3.4,3.4,0,0,0,278.7,177.6Z"
                  transform="translate(-134.9 -35)"
                />
                <path
                  class="cls-3"
                  d="M280,185.1a2.1,2.1,0,0,1-1.6-1.1c-.9-1.4-1.6-4.4-.1-6.6h0a3.8,3.8,0,0,1,3-1.8,3.7,3.7,0,0,1,3.2,1.4,5.2,5.2,0,0,1,0,5.4,7.3,7.3,0,0,1-4.2,2.7Zm-1-7.3a6,6,0,0,0,.1,5.8c.4.6.8.8,1.1.8a5.9,5.9,0,0,0,3.7-2.4,4.7,4.7,0,0,0,.1-4.6,3.2,3.2,0,0,0-2.6-1.1,2.9,2.9,0,0,0-2.4,1.5Z"
                  transform="translate(-134.9 -35)"
                />
              </g>
            </g>
            <g id="Vector_1382" data-name="Vector 1382">
              <path
                class="cls-3"
                d="M282.4,175.3c-2.2-.3-3.6.6-4,1.7a3.5,3.5,0,0,0-.3,1.9c.3-.5.6-1.3,1.9-.8a3.6,3.6,0,0,1,2.7,3.3h.5c.1-.6.4-.8.8-.6s.3,1.5.3,1.5a4.5,4.5,0,0,0,1.3-3.1A3.9,3.9,0,0,0,282.4,175.3Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M284.2,182.5H284c-.1-.1-.2-.2-.2-.3s0-1.1-.2-1.2h-.1a.6.6,0,0,0-.1.4l-.2.3h-.6c-.1,0-.2,0-.2-.1a.4.4,0,0,1-.1-.3,3.2,3.2,0,0,0-2.5-2.9c-.9-.3-1.1,0-1.3.4l-.2.2H278l-.3-.2a3.6,3.6,0,0,1,.3-2.2c.5-1.1,1.9-2.2,4.4-1.9h0c2.4.3,3.4,2.9,3.4,4.2a4.9,4.9,0,0,1-1.4,3.3Zm-.5-2.2h.5a2,2,0,0,1,.4.8,4,4,0,0,0,.7-2.1,3.6,3.6,0,0,0-2.8-3.5h0c-2.1-.3-3.3.6-3.7,1.5a1.9,1.9,0,0,0-.2.7,1.6,1.6,0,0,1,1.6-.1,4.1,4.1,0,0,1,2.9,3,1,1,0,0,1,.4-.5C283.5,180.3,283.6,180.3,283.7,180.3Z"
                transform="translate(-134.9 -35)"
              />
            </g>
          </g>
        </g>
        <g id="Graph1">
          <polygon
            class="cls-2"
            points="62.9 159.8 63.1 159.9 64.5 159.1 68 157.1 67 156.5 62 159.3 62.9 159.8"
          />
          <polygon class="cls-2" points="70.1 155.9 74.6 153.3 73.5 152.7 70.1 154.7 70.1 155.9" />
          <polygon class="cls-2" points="69.4 134.8 69.1 134.6 69.1 156.5 69.4 156.3 69.4 134.8" />
          <polygon class="cls-2" points="48.3 143.2 52.8 140.6 51.8 140 48.3 142 48.3 143.2" />
          <polygon class="cls-2" points="41.3 147.3 46.2 144.4 45.2 143.8 40.2 146.6 41.3 147.3" />
          <polygon
            class="cls-2"
            points="47.6 122.2 47.2 122 47.2 143.8 47.2 143.8 47.6 143.6 47.6 122.2"
          />
          <path
            class="cls-2"
            d="M211.1,172.9V143l-36.4-21.1v30ZM175.7,152h0l-.3-.2-.2-.3V123.7c0-.1.1-.2.2-.3s.2-.1.4,0l.3.2h.1l33.9,19.6.2.3v27.3h0v.4h-.5Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M176.3,124.5V151l33.3,19.3V143.8ZM196.2,160l-.2.3h-.4l-17.3-10-.2-.3V132.1c0-.1.1-.3.2-.3s.3,0,.4.1h.1v17.7l1,.6V136l.2-.3h.3l1.7,1,.2.3v14.7l.5.3V140.5l.2-.3h.4l1.6,1,.2.3v11.8l.6.3v-9.9l.2-.3h.3l1.6.9.2.3v10.3l.6.3v-7.8l.2-.3h.3l1.7.9c.1.1.2.2.2.3v8.2l.3.2v-5.4c0-.1.1-.2.2-.3h.3l1.7,1c.1.1.2.2.2.3V158l2.3,1.3.2.3v.4Zm9.8,3.8a3.3,3.3,0,0,1-1.4.4,4.2,4.2,0,0,1-2.1-.6c-2.8-1.6-5-5.7-5-9.4h0a4.6,4.6,0,0,1,1.8-4.1,3.6,3.6,0,0,1,3.3.2h.2c2.7,1.5,4.9,5.7,5,9.4A4.7,4.7,0,0,1,206,163.8Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M209.8,171.6h.5v-.4h0V143.6l-.2-.3-33.9-19.6H176l-.3-.2c-.1-.1-.2-.1-.4,0s-.2.2-.2.3v27.8l.2.3.3.2h0ZM176.3,151V124.4l33.3,19.3v26.5Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M212.4,142.4h-.1l-37-21.6a.2.2,0,0,0-.3,0l-.7.3h-.2v30.8c0,.1.1.2.2.3l5.5,3.2v22.6l-5.5,3.1h-.1v.6l.2.3,1.8,1h.4l12.2-7,.2-.3v-.7h-.2l-1.7-1h-.3l-3.3,1.9V157.5l18.3,10.6v22.7L196,194h0c-.1.1-.2.2-.2.3v.6l.2.3,1.7,1h.4l12.3-7.1.2-.3v-.6h-.2l-1.8-1a.2.2,0,0,0-.3,0l-3.2,1.9V170l6.3,3.6h.4l.6-.3.2-.3V142.3C212.5,142.5,212.5,142.4,212.4,142.4Zm-10.5,49.1,1,.6-3.5,2-1.4.8h-.2l-.8-.5Zm7.6-3.2-4.5,2.6v-1.2l3.4-2Zm-5.2,3-.3.2V169.6l.3.2Zm-29.6-39.4v-30L211.1,143v29.9Zm5.4,26.9,1.1.6-4.9,2.9-1.1-.6Zm7.6-3.2-4.5,2.6V177l3.5-2Zm-5.2,3-.3.2h0V157l.3.2Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M203,151.2v5.7h0l-.2.3h-.4l-4.3-2.5c.3,3.2,2.2,6.8,4.6,8.1a2.9,2.9,0,0,0,2.8.3c.9-.5,1.5-1.9,1.5-3.6A11.4,11.4,0,0,0,203,151.2Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M202.8,150.2h-.2a3.3,3.3,0,0,0-3.3-.2c-1.2.6-1.8,2.1-1.8,4.1h0c0,3.7,2.2,7.8,5,9.4a4.2,4.2,0,0,0,2.1.6,2.3,2.3,0,0,0,1.4-.4c1.2-.7,1.8-2.2,1.8-4.2S205.5,151.8,202.8,150.2Zm2.8,13a2.9,2.9,0,0,1-2.8-.3c-2.4-1.4-4.4-4.9-4.6-8.1l4.3,2.5h.4l.2-.3h0v-5.7a11.4,11.4,0,0,1,4.1,8.4C207.1,161.3,206.6,162.6,205.6,163.2Zm-5.9-12.6a2.7,2.7,0,0,1,2.6.2v5.5h0l-4.1-2.4C198.2,152.3,198.8,151.1,199.7,150.6Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M198.2,154l4.1,2.4h0v-5.5a2.7,2.7,0,0,0-2.6-.2C198.8,151.1,198.2,152.3,198.2,154Z"
            transform="translate(-134.9 -35)"
          />
          <polygon class="cls-2" points="46.8 116.3 46.8 102.1 45.8 101.6 45.8 115.7 46.8 116.3" />
          <polygon class="cls-2" points="49.6 117.9 49.6 106.7 48.7 106.1 48.7 117.4 49.6 117.9" />
          <polygon class="cls-2" points="52.5 119.5 52.5 109.8 51.6 109.3 51.6 119 52.5 119.5" />
          <polygon class="cls-2" points="55.4 121.2 55.4 113.6 54.4 113.1 54.4 120.6 55.4 121.2" />
          <polygon class="cls-2" points="58.1 122.8 58.1 117.6 57.1 117 57.1 122.2 58.1 122.8" />
          <path
            class="cls-3"
            d="M196,159.5l-2.3-1.3v-5.7l-.2-.3-1.7-1h-.3l-.2.3v5.4l-.3-.2v-8.2l-.2-.3-1.7-.9a.2.2,0,0,0-.3,0l-.2.3v7.8l-.6-.3V144.8c0-.1-.1-.2-.2-.3l-1.6-.9h-.3l-.2.3v9.9l-.6-.3V141.7l-.2-.3-1.6-1h-.4l-.2.3V152l-.5-.3V137l-.2-.3-1.7-1H180l-.2.3v14.3l-1-.6V132.2c0-.1,0-.2-.1-.2h-.5l-.2.3V150l.2.3,17.3,10h.4l.2-.3h0C196.2,159.7,196.2,159.6,196,159.5Zm-14.3-22.4v14.1l-1-.6V136.5Zm2.8,4.6v11.2l-.9-.5V141.2Zm2.9,3.1v9.7l-.9-.5v-9.7Zm2.9,3.8v7.6l-1-.6V148Zm2.7,4v5.1l-1-.6V152Z"
            transform="translate(-134.9 -35)"
          />
        </g>
        <g id="Lady_1" data-name="Lady 1">
          <g id="Vector_1312" data-name="Vector 1312">
            <path
              class="cls-3"
              d="M222.2,143.7c-3.3-1.1-3.7,2.7-3.7,2.7-.3,14.5,6.3,14.3,6.3,14.3a34.2,34.2,0,0,0,.3-5.8C225.2,151.7,225.4,144.9,222.2,143.7Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M224.8,161a5.1,5.1,0,0,1-3.3-1.6c-1.6-1.6-3.5-5.2-3.3-13a4,4,0,0,1,1.5-2.8,2.9,2.9,0,0,1,2.6-.2h0c3.5,1.3,3.3,7.8,3.2,11.3v.2a22.4,22.4,0,0,1-.4,5.8.3.3,0,0,1-.3.3ZM221,143.8a1.7,1.7,0,0,0-1,.3,3.7,3.7,0,0,0-1.2,2.3c-.2,7.5,1.6,11,3.1,12.5a4.7,4.7,0,0,0,2.6,1.4,31.4,31.4,0,0,0,.3-5.4v-.2c.1-3.1.2-9.6-2.8-10.6A1.9,1.9,0,0,0,221,143.8Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1313" data-name="Vector 1313">
            <path
              class="cls-5"
              d="M206.8,166l-2.6,1c-1.3.6-1.4.6-1.1.8s.8-.1,1,0-.5.7-.8,1.7.9,1.4,1.7.8l1.2-1.1a10.4,10.4,0,0,1,1.5-1.5,5.4,5.4,0,0,0,1.2-1.4A2.3,2.3,0,0,0,206.8,166Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M203.9,171.1l-.6-.2c-.3-.2-.5-.6-.3-1.5a3.9,3.9,0,0,1,.6-1.3c-.3,0-.5.1-.7-.1a.6.6,0,0,1-.3-.5c0-.3.2-.4.9-.7l.5-.2,2.6-1a3.2,3.2,0,0,1,2.5.3c.2.1.2.3.1.5a9.6,9.6,0,0,1-1.3,1.5,5.9,5.9,0,0,0-.8.8l-.6.6a5,5,0,0,1-1.3,1.2A1.6,1.6,0,0,1,203.9,171.1Zm.2-3.7h0c.2,0,.3.2.4.3s0,.4-.2.7a6.7,6.7,0,0,0-.6,1.2c-.1.4-.1.6,0,.7a1.6,1.6,0,0,0,1.2-.3,3.8,3.8,0,0,0,1.1-1.1l.6-.6c.4-.4.7-.8,1-.9a9,9,0,0,0,.9-1,1.9,1.9,0,0,0-1.5-.1h0a18.7,18.7,0,0,0-2.5,1Zm2.7-1.4Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1314" data-name="Vector 1314">
            <path
              class="cls-5"
              d="M219.6,184.1c.3-.8-4.7-3.3-4.7-3.3a36.4,36.4,0,0,1,.5,4.3,23.6,23.6,0,0,0,.3,3.5,92,92,0,0,1,.7,9.6,9.6,9.6,0,0,1-1.7,4.6c-.5.7,1,1.9,2.1.8a14.3,14.3,0,0,1,1.8-1.6c.6-.3,1.1-1.7.6-3.3s-.3-4.7.3-7.5S219.3,184.9,219.6,184.1Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M215.9,204.4a2.1,2.1,0,0,1-1.1-.4,1,1,0,0,1-.3-1.4v-.2a8.6,8.6,0,0,0,1.5-4.2,94.1,94.1,0,0,0-.7-9.6,15.6,15.6,0,0,1-.4-3.5,36.8,36.8,0,0,0-.5-4.2c0-.1,0-.3.1-.3h.4c3.5,1.7,5.1,3,4.9,3.7a12.7,12.7,0,0,0,0,2,21.7,21.7,0,0,1,0,5.1,18.7,18.7,0,0,0-.3,7.3c.5,1.8,0,3.3-.8,3.8a5.8,5.8,0,0,0-1,.8l-.7.7A2.8,2.8,0,0,1,215.9,204.4Zm-.5-23c.1,1,.4,2.7.4,3.6a21.4,21.4,0,0,0,.3,3.4,96.1,96.1,0,0,1,.7,9.7,9.5,9.5,0,0,1-1.6,4.6v.2a.4.4,0,0,0,.2.5,1.1,1.1,0,0,0,1.4-.1,4.5,4.5,0,0,0,.7-.7,3.9,3.9,0,0,1,1.1-.9c.4-.2.9-1.4.5-3s-.2-5.3.3-7.6a20.1,20.1,0,0,0,0-4.9,7.6,7.6,0,0,1,0-2.2A17.6,17.6,0,0,0,215.4,181.4Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1315" data-name="Vector 1315">
            <path
              class="cls-2"
              d="M219.4,199.2a4.6,4.6,0,0,1-1.9,3.1c-1.5.8-2.1,1-2.9.4a12.1,12.1,0,0,0-1.8,1.7c-.5.6,1,1.4,2.3.9a14.5,14.5,0,0,0,3.5-2.6c1-.9,1.3-1.3,1.3-2.3A2.2,2.2,0,0,0,219.4,199.2Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M214.3,205.8a2.3,2.3,0,0,1-1.8-.7.7.7,0,0,1,0-.9,8.5,8.5,0,0,1,1.9-1.7h.4c.6.4,1,.4,2.5-.4a4.3,4.3,0,0,0,1.7-2.8c0-.1.1-.2.2-.3h.4a1.8,1.8,0,0,1,.6,1.4c.1,1.1-.3,1.6-1.4,2.5l-.7.7a8.6,8.6,0,0,1-2.9,2.1A2.7,2.7,0,0,0,214.3,205.8Zm.4-2.7a11.7,11.7,0,0,0-1.6,1.5l.2.2a2,2,0,0,0,1.7.1,7.9,7.9,0,0,0,2.6-1.9l.7-.7c1-.9,1.2-1.1,1.1-2v-.2a4.7,4.7,0,0,1-1.8,2.5C216.3,203.4,215.5,203.6,214.7,203.1Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1316" data-name="Vector 1316">
            <path
              class="cls-5"
              d="M224,180.4c-1.3-.8-4.9,2.8-4.9,2.8s.1,2.9.2,4.3a9.9,9.9,0,0,0,.6,3.2,75.3,75.3,0,0,1,.7,9.8,9.6,9.6,0,0,1-1.7,4.6c-.5.7,1,1.9,2.1.8a14.3,14.3,0,0,1,1.8-1.6c.6-.3,1.1-1.7.6-3.3s-.3-4.7.3-7.5-.3-6.2-.1-7.1S225.2,181.1,224,180.4Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M220.1,206.7a2.1,2.1,0,0,1-1.1-.4,1,1,0,0,1-.3-1.4v-.2a8.6,8.6,0,0,0,1.5-4.2c0-2.1-.3-8.4-.7-9.7l-.2-.7a7.5,7.5,0,0,1-.4-2.6c-.1-1.3-.2-4.2-.2-4.2a.4.4,0,0,1,.1-.3c.6-.6,3.9-3.7,5.3-2.8s.6,2.9.1,5l-.3,1.4a6.1,6.1,0,0,0,.1,1.8,15.7,15.7,0,0,1,0,5.3,18.7,18.7,0,0,0-.3,7.3c.5,1.8,0,3.3-.8,3.8a5.8,5.8,0,0,0-1,.8l-.7.7A2.5,2.5,0,0,1,220.1,206.7Zm-.6-23.4c0,.6.1,3,.2,4.1a6.1,6.1,0,0,0,.4,2.4l.2.7a76.9,76.9,0,0,1,.7,9.9,9.5,9.5,0,0,1-1.6,4.6v.2a.4.4,0,0,0,.2.5,1,1,0,0,0,1.4-.1l.7-.7a3.9,3.9,0,0,1,1.1-.9c.4-.2.9-1.4.5-3s-.2-5.1.3-7.6a21.7,21.7,0,0,0,0-5.1,7.6,7.6,0,0,1-.1-2l.3-1.4c.4-1.6.9-3.8.2-4.2h0C223.2,180.3,220.9,182,219.5,183.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1317" data-name="Vector 1317">
            <path
              class="cls-2"
              d="M223.6,201.6a4.6,4.6,0,0,1-1.9,3.1c-1.5.8-2.1,1-2.9.4a12.1,12.1,0,0,0-1.8,1.7c-.5.6,1,1.4,2.3.9a12.7,12.7,0,0,0,3.5-2.7c1-.9,1.3-1.3,1.3-2.3A1.4,1.4,0,0,0,223.6,201.6Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M218.5,208.2a2.3,2.3,0,0,1-1.8-.7.8.8,0,0,1,0-.9,8.5,8.5,0,0,1,1.9-1.7h.4c.6.4,1,.4,2.5-.4a4.3,4.3,0,0,0,1.7-2.8l.2-.3h.4a1.8,1.8,0,0,1,.6,1.4c.1,1.1-.3,1.6-1.4,2.5l-.7.7a8.6,8.6,0,0,1-2.9,2.1Zm.4-2.7a11.7,11.7,0,0,0-1.6,1.5l.2.2a2,2,0,0,0,1.7.1,7.9,7.9,0,0,0,2.6-1.9l.7-.7c1-.9,1.2-1.1,1.1-2v-.2a4.7,4.7,0,0,1-1.8,2.5C220.6,205.7,219.8,206,218.9,205.5Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1318" data-name="Vector 1318">
            <path
              class="cls-2"
              d="M214.1,169.7s-.1,3.2-.1,5.9,0,7.8,0,7.8,4.6,3.4,8.3,2.2c.2-1,.6-3.4.6-3.4a7.4,7.4,0,0,1,.5,3.2,5.9,5.9,0,0,0,2-1s.1-9.1-1.3-13.9S214.1,167.1,214.1,169.7Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M220.5,186.3a12.4,12.4,0,0,1-6.8-2.6.4.4,0,0,1-.1-.3s-.1-4.6,0-7.8.1-5.9.1-5.9h0c0-1.5,2.1-2.5,4.1-2.8s5.5.4,6.4,3.4c1.4,4.9,1.3,13.7,1.3,14a.4.4,0,0,1-.1.3,5.4,5.4,0,0,1-2.1,1.1H223a.4.4,0,0,1-.1-.3,7.5,7.5,0,0,0,0-1.5c-.1.7-.2,1.4-.3,1.8l-.2.3A4.3,4.3,0,0,1,220.5,186.3Zm-6.2-3c.8.5,4.5,3,7.7,2.1.2-1.1.5-3.2.5-3.2a.3.3,0,0,1,.3-.3.4.4,0,0,1,.4.2,7,7,0,0,1,.6,2.9l1.2-.7c0-1.3-.1-9.3-1.3-13.7-.7-2.6-3.5-3.2-5.6-2.9s-3.5,1.2-3.5,2.1-.1,3.2-.1,5.9A74.4,74.4,0,0,0,214.3,183.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1319" data-name="Vector 1319">
            <path
              class="cls-2"
              d="M221.2,154.9a7.2,7.2,0,0,1-1.3,2.4c-.6.5-1.6,1.7-1.7,1.7a10.7,10.7,0,0,1,.8-3.4,6.2,6.2,0,0,0-.1-2.1h-.6c-.6.6-1.6,2.2-2.2,2.8s-2.2,2.8-1.7,4.9a26.7,26.7,0,0,1,.6,5,39,39,0,0,1-1.1,4.2,7.3,7.3,0,0,0,4.9,2,7.8,7.8,0,0,0,4.9-2.2,43.3,43.3,0,0,1-.6-6.1,4.8,4.8,0,0,0,2.4-4.9C225.2,157.3,221.2,154.9,221.2,154.9Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M218.7,172.6a7.9,7.9,0,0,1-5-2.1c-.1-.1-.1-.2-.1-.4a35.9,35.9,0,0,0,1.1-4.1,24.9,24.9,0,0,0-.6-4.8c-.6-2.5,1.5-4.9,1.8-5.2l.9-1.2a13.2,13.2,0,0,1,1.2-1.6h.9l.3.3a8.3,8.3,0,0,1,.1,2.3,12.3,12.3,0,0,0-.6,2.2l1-.9a8.2,8.2,0,0,0,1.1-2.3.2.2,0,0,1,.2-.2h.3c.4.3,4.2,2.6,4.5,4.4a4.9,4.9,0,0,1-2.4,5.1c0,1.9.6,5.8.6,5.9a.4.4,0,0,1-.1.3,8.3,8.3,0,0,1-5.1,2.3Zm-4.3-2.5a7,7,0,0,0,4.5,1.8,7.6,7.6,0,0,0,4.5-1.9,44.8,44.8,0,0,1-.6-6l.2-.3a4.4,4.4,0,0,0,2.2-4.5c-.2-1.2-2.6-2.9-3.8-3.7a5.9,5.9,0,0,1-1.2,2.2,20.6,20.6,0,0,0-1.5,1.6v.2h-.4l-.2-.3a11,11,0,0,1,.8-3.5,9.5,9.5,0,0,0,0-1.7h-.2a5.6,5.6,0,0,0-1,1.4l-1,1.3c-.8.9-2,2.8-1.6,4.6a26.7,26.7,0,0,1,.6,5C215.4,166.9,214.6,169.4,214.4,170.1Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1320" data-name="Vector 1320">
            <path
              class="cls-2"
              d="M214.6,155.5a53.8,53.8,0,0,0-2.7,6.6l-2.9,1.8-3,2a4,4,0,0,1,.9,1.1,4.4,4.4,0,0,1,.3,1.4,12.6,12.6,0,0,0,3.6-1.3,8.8,8.8,0,0,0,2.8-2c2.2-2.3,5.4-11.4,5.4-11.4S216.8,151.6,214.6,155.5Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M207.3,168.7h-.2a.4.4,0,0,1-.1-.3,3.7,3.7,0,0,0-.3-1.3,3.2,3.2,0,0,0-.8-1,.4.4,0,0,1-.1-.3l.2-.3,3-2,2.8-1.8a13.1,13.1,0,0,0,.5-1.5,32.6,32.6,0,0,1,2.1-5,4.4,4.4,0,0,1,2.8-2.5,2.7,2.7,0,0,1,2.2.7c.1.1.1.2.1.4s-3.3,9.2-5.5,11.5a9,9,0,0,1-2.9,2,9.9,9.9,0,0,1-3.8,1.5Zm-.7-2.8.7.9a2.6,2.6,0,0,1,.3,1.1,13,13,0,0,0,3.1-1.1,8.5,8.5,0,0,0,2.7-1.9c1.9-2,4.8-9.6,5.3-11a2,2,0,0,0-1.4-.4c-.8.1-1.6.8-2.3,2.1h0a27.8,27.8,0,0,0-2,4.9l-.6,1.6-.2.2-2.9,1.8Zm8-10.4Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1321" data-name="Vector 1321">
            <path
              class="cls-2"
              d="M216.2,155.8c-1.7,2.2-2.2,2.9-1.7,5.3s-1.1,9.6-1.1,9.6,1.7-.1,2.2-1.5.2-7,1-9.2l1.7-4.7-.4-1.3C217.8,154.1,217.8,153.7,216.2,155.8Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M213.8,171.3l-.7-.2c-.1-.1-.2-.2-.1-.4s1.6-7.1,1.1-9.5.1-3.3,1.6-5.4l.2-.2h0c1.6-2.1,1.7-2,2-1.9a.2.2,0,0,1,.2.2h0l.4,1.3v.2s-.8,2.5-1.7,4.7a42.9,42.9,0,0,0-.9,6.9,20.8,20.8,0,0,1-.2,2.2,2.5,2.5,0,0,1-1.5,1.9C214.2,171.3,214,171.3,213.8,171.3Zm-.1-.7h.4a2.2,2.2,0,0,0,1-1.4,18,18,0,0,0,.2-2.1c.1-2.4.3-5.6.9-7.1s1.5-4,1.6-4.6l-.2-.7a7.3,7.3,0,0,0-1.1,1.4l-.2.2c-1.5,2-1.9,2.6-1.5,4.8S214,169.2,213.7,170.6Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1322" data-name="Vector 1322">
            <path
              class="cls-2"
              d="M218.7,155.3s-.6-.8-.9-.8l-1.9,2.5.5.7a2.7,2.7,0,0,0-.8.7c0,1.1.3,4.3.3,4.3a23.7,23.7,0,0,1,2.4-6.4C219,155.3,218.7,155.3,218.7,155.3Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M216,163.1h0a.3.3,0,0,1-.3-.3c0-.1-.4-3.2-.4-4.3v-.2a1.7,1.7,0,0,1,.6-.6l-.3-.4a.3.3,0,0,1,0-.4l1.9-2.5h.2c.3-.1.7.2,1.2.8l.2.2c.1.3,0,.7-.4,1.3a22.5,22.5,0,0,0-2.4,6.3Zm0-4.5c0,.5.1,1.4.2,2.2a19.4,19.4,0,0,1,2-4.6,1.5,1.5,0,0,0,.3-.6h0l-.5-.6-1.6,2.1.3.5a.4.4,0,0,1,.1.3l-.2.2A1.2,1.2,0,0,0,216,158.6Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1323" data-name="Vector 1323">
            <path
              class="cls-2"
              d="M220.9,145.1a1.6,1.6,0,0,0-2,.8l3.2,1.3A2.2,2.2,0,0,0,220.9,145.1Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M222.1,147.5H222l-3.2-1.3a.2.2,0,0,1-.2-.2v-.3a1.9,1.9,0,0,1,2.5-.9h0a2.7,2.7,0,0,1,1.4,2.4c0,.1-.1.2-.2.3Zm-2.7-1.8,2.2.9a1.7,1.7,0,0,0-.9-1.2A1.2,1.2,0,0,0,219.4,145.7Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Group_182" data-name="Group 182">
            <g id="Vector_1324" data-name="Vector 1324">
              <path
                class="cls-5"
                d="M218.7,153.8a12.1,12.1,0,0,1-.3,2.7c-.6,1.5,1.1,1.5,1.7,1a7.5,7.5,0,0,0,1.9-2.1l-.3-4.8Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M219.2,158.1l-.9-.3a1.2,1.2,0,0,1-.2-1.5,22.3,22.3,0,0,0,.3-2.6c0-.1,0-.2.1-.2l3-3.2h.4c.1,0,.2.2.2.3l.3,4.8v.2a8.1,8.1,0,0,1-2,2.2A1.7,1.7,0,0,1,219.2,158.1ZM219,154a10,10,0,0,1-.3,2.7c-.1.3-.2.6,0,.7a1.3,1.3,0,0,0,1.2-.1,6,6,0,0,0,1.7-1.9l-.3-3.9Z"
                transform="translate(-134.9 -35)"
              />
            </g>
            <g id="Vector_1325" data-name="Vector 1325">
              <path
                class="cls-5"
                d="M220.5,147.5a3.1,3.1,0,0,0-4.8,1.9c-.9,3,2,6.6,3.3,5.9a5,5,0,0,0,2.8-2.9C222.2,150.6,221.4,148.2,220.5,147.5Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M218.6,155.8a2.4,2.4,0,0,1-1.4-.6,6.1,6.1,0,0,1-1.9-5.8,3.5,3.5,0,0,1,2.2-2.5,3.8,3.8,0,0,1,3.2.4c1,.7,1.9,3.3,1.5,5.2a5.9,5.9,0,0,1-3,3.2Zm.1-8.4a1.5,1.5,0,0,0-.9.2,2.9,2.9,0,0,0-1.7,2,5.1,5.1,0,0,0,1.7,5.1c.5.4.9.6,1.2.4a4.9,4.9,0,0,0,2.6-2.7c.4-1.7-.4-4-1.2-4.5h0A3.4,3.4,0,0,0,218.7,147.4Z"
                transform="translate(-134.9 -35)"
              />
            </g>
            <g id="hair">
              <path
                class="cls-3"
                d="M220.4,145.9c-1.7-.6-2.8.1-4.3,1.5a4.3,4.3,0,0,0-1.2,3.6,14,14,0,0,0,4,1.8,2.8,2.8,0,0,0,1.7-.4l.7-.7c.2-.1.6-.1.6.1s0,.8.1,1.4a7.5,7.5,0,0,0,1-3.6A3.6,3.6,0,0,0,220.4,145.9Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M221.8,153.5h0a.3.3,0,0,1-.3-.3v-1.3h0l-.6.6h-.1a4.1,4.1,0,0,1-1.9.5,13.1,13.1,0,0,1-4.1-1.9l-.2-.3a4.5,4.5,0,0,1,1.3-3.8c1.6-1.6,2.9-2.3,4.7-1.6h.1a3.8,3.8,0,0,1,2.6,4.1,8.9,8.9,0,0,1-1.1,3.7C222.1,153.5,222,153.5,221.8,153.5Zm-6.6-2.7a16.1,16.1,0,0,0,3.7,1.7,3.3,3.3,0,0,0,1.4-.4,2.3,2.3,0,0,1,.7-.7.8.8,0,0,1,.8-.1c.2.1.3.2.3.4a6.5,6.5,0,0,0,.4-2.1,3.1,3.1,0,0,0-2.2-3.4h-.1c-1.5-.6-2.5,0-4,1.5A4.1,4.1,0,0,0,215.2,150.8Zm6.2,1Z"
                transform="translate(-134.9 -35)"
              />
            </g>
          </g>
          <g id="Vector_1327" data-name="Vector 1327">
            <path
              class="cls-2"
              d="M225.2,157.7a18.1,18.1,0,0,0-3.1-2.9,15.5,15.5,0,0,0-3.5,7.1c-.2,1.2-.8,3.8-1,6s.3,4.4,1.2,5.2c2.8,2.2,6.1-1.1,6.1-1.1s-1.4-4.5-1.2-5.9S225.7,158.7,225.2,157.7Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M220.8,174.2a3.4,3.4,0,0,1-2.3-.8c-1-.8-1.5-2.9-1.3-5.5a34.9,34.9,0,0,1,.8-5,5.2,5.2,0,0,0,.2-1.1,16.1,16.1,0,0,1,3.6-7.3h.5c.3.2,2.7,2,3.2,3h0c.4.7,0,3.1-1.1,7.1l-.4,1.5c-.2,1.1.8,4.5,1.2,5.7a.6.6,0,0,1-.1.4A6.6,6.6,0,0,1,220.8,174.2Zm1.3-18.9a15.6,15.6,0,0,0-3.2,6.7,5.2,5.2,0,0,1-.2,1.1,33.4,33.4,0,0,0-.8,4.9c-.1,2.3.3,4.2,1.1,4.9s4.9-.4,5.5-1-1.3-4.5-1.1-5.8.2-.9.4-1.6,1.5-6,1.1-6.6h0A17.9,17.9,0,0,0,222.1,155.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1328" data-name="Vector 1328">
            <path
              class="cls-2"
              d="M219.9,157.7a13.6,13.6,0,0,0-1.6,5.9l2.9-3.7-.5-1,1-.7a14.5,14.5,0,0,0,1-2.4c.1-.8-.9-1.9-.9-1.9Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M218.3,163.9h-.1c-.1,0-.2-.2-.2-.3a13.6,13.6,0,0,1,1.6-6h0l2-3.9c.1-.1.1-.2.3-.2h.3c.1.1,1.1,1.2,1,2.1a9.7,9.7,0,0,1-1.1,2.6H222l-.8.5.4.8c.1.1,0,.3,0,.4l-2.9,3.7Zm1.9-6a16.1,16.1,0,0,0-1.5,4.6l2.1-2.6-.4-.9c-.1-.2,0-.3.1-.4l1-.6a11,11,0,0,0,1-2.2,1.8,1.8,0,0,0-.5-1.2A34.7,34.7,0,0,0,220.2,157.9Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="woman-arm">
            <g id="Vector_1329" data-name="Vector 1329">
              <path
                class="cls-5"
                d="M217.7,171.5a3.5,3.5,0,0,0-1.5.7c-.6.4-1.6.9-1.4,1a6.2,6.2,0,0,0,1.3-.1c.3-.1-.1.6-.6,1.2a1.7,1.7,0,0,0-.5,1.9c.3.7,1.9-.7,2.6-1.4l2-2.2-.5-1.6A3.6,3.6,0,0,1,217.7,171.5Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M215.3,176.7h-.1a.7.7,0,0,1-.5-.4,2.1,2.1,0,0,1,.6-2.3l.4-.5h-1.1c-.1-.1-.2-.2-.2-.3s.3-.5,1-.9l.6-.3a5.9,5.9,0,0,1,1.6-.7h0a3.6,3.6,0,0,0,1.3-.5.2.2,0,0,1,.3,0,.2.2,0,0,1,.2.2l.5,1.6a.4.4,0,0,1-.1.3l-2,2.2A4.7,4.7,0,0,1,215.3,176.7Zm.8-3.9.3.2c.3.4-.5,1.3-.7,1.6a1.4,1.4,0,0,0-.4,1.5h0a6.3,6.3,0,0,0,2-1.5l1.8-2.1-.3-1-1.1.4a6.4,6.4,0,0,0-1.4.6l-.5.3h.3Z"
                transform="translate(-134.9 -35)"
              />
            </g>
            <g id="Vector_1330" data-name="Vector 1330">
              <path
                class="cls-2"
                d="M224.5,157.2a4.4,4.4,0,0,0-2.4,3.6,47,47,0,0,0,.2,6.6c-.6.3-5.1,3.8-5.1,3.8a4.6,4.6,0,0,1,1.2,1.4,3.6,3.6,0,0,1,.3,1.4s5-2.6,6.5-3.6,1.2-2.3,1.2-4,.1-3.6.1-5.3S226.1,157.5,224.5,157.2Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M218.8,174.3h-.2l-.2-.3a2.7,2.7,0,0,0-.3-1.2,4,4,0,0,0-1.1-1.3.5.5,0,0,1,0-.6c.4-.3,3.9-3.1,4.9-3.7a44.7,44.7,0,0,1-.2-6.4c.2-1.8,1.4-3.5,2.6-3.8h.2c1.4.3,2.2,1.7,2.3,4.2v2.2c0,1.1-.1,2.2,0,3.1v.7c0,1.4.1,2.7-1.4,3.6s-6.3,3.5-6.5,3.6Zm-1-3.1a3.8,3.8,0,0,1,.9,1.2,1.9,1.9,0,0,1,.3,1c1.3-.7,4.8-2.5,6-3.3s1.1-1.6,1-3v-6c-.1-2.1-.6-3.2-1.7-3.5a4.1,4.1,0,0,0-2,3.2,45.1,45.1,0,0,0,.2,6.5l-.2.4Z"
                transform="translate(-134.9 -35)"
              />
            </g>
          </g>
          <g id="Group_183" data-name="Group 183">
            <g id="Vector_1331" data-name="Vector 1331">
              <path
                class="cls-2"
                d="M223.5,156.1a23.3,23.3,0,0,0-3,2.9c-1.8,2-3.3,6.5-3.8,7.3-.3-1-.9-6.1-.5-8a6.7,6.7,0,0,1,1.5-3.2l-.3-.2a7.1,7.1,0,0,0-1.6,3.3c-.6,2.4.6,8.4.6,8.6v.1s1.7-5.1,4-7.6,2.6-2.4,3-2.9a.2.2,0,0,0,0-.3Z"
                transform="translate(-134.9 -35)"
              />
              <path
                class="cls-3"
                d="M216.6,167.6h0c-.2,0-.3-.1-.3-.2V167c-.1-.2-1.2-6.3-.6-8.8a7.4,7.4,0,0,1,1.7-3.5c.1-.1.3-.2.4-.1s.2.1.2.2.2.2.2.3a.4.4,0,0,1-.1.3,7.8,7.8,0,0,0-1.5,3.1,26.4,26.4,0,0,0,.3,6.8c.1-.1.1-.3.2-.4a24.3,24.3,0,0,1,3.3-6.1,17.9,17.9,0,0,1,2.5-2.4l.5-.4c.1-.1.4-.2.5-.1l.3.3c0,.1.1.2.1.3a.8.8,0,0,1-.2.4l-.6.6c-.6.6-1.6,1.4-2.4,2.3s-3.9,7.4-3.9,7.5v.4C216.9,167.5,216.7,167.6,216.6,167.6Z"
                transform="translate(-134.9 -35)"
              />
            </g>
          </g>
          <g id="Vector_1332" data-name="Vector 1332">
            <path
              class="cls-2"
              d="M215.4,168.5l2.2,1.3.3-3.5-2.2-1.3Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M217.6,170.1h-.2l-2.2-1.3-.2-.3.3-3.5.2-.3h.3L218,166c.1.1.2.2.2.3l-.3,3.5-.2.3Zm-1.8-1.8,1.6.9.2-2.7-1.6-.9Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1333" data-name="Vector 1333">
            <path
              class="cls-2"
              d="M215.8,165.7l1.9,1.1v-.4l-1.9-1.1Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M217.7,167.1h-.2l-1.9-1.1c-.1-.1-.2-.2-.2-.3v-.4c0-.1.1-.2.2-.3h.4l1.9,1.1.2.3v.4l-.2.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
          <g id="Vector_1334" data-name="Vector 1334">
            <path
              class="cls-2"
              d="M216.3,168.7l1.1.6.2-2.3-1.2-.6Z"
              transform="translate(-134.9 -35)"
            />
            <path
              class="cls-3"
              d="M217.4,169.7h-.2l-1.1-.6-.2-.3v-2.3l.2-.3h.3l1.2.6.2.3-.2,2.3-.2.3Zm-.7-1.2.5.3v-1.5l-.5-.3Z"
              transform="translate(-134.9 -35)"
            />
          </g>
        </g>
      </g>
      <g class="cls-6">
        <g id="jamstack-logo">
          <path
            class="cls-2"
            d="M143.1,73.7c0,.3.1.7.1,1s.1.5.1.8.1.7.2,1,.1.6.2.9.1.6.2.9a5.6,5.6,0,0,0,.4,1.2c.1.2.1.4.2.6l.6,1.6v.2a38.2,38.2,0,0,0,12.6,16.8v-17l-14.8-8.6Z"
            transform="translate(-134.9 -35)"
          />
          <polygon class="cls-2" points="26.4 48.9 26.3 65.1 32.8 61.4 40.4 56.9 26.4 48.9" />
          <path
            class="cls-2"
            d="M162,101.3a12.4,12.4,0,0,0,6.3,1.1h.1l.9-.2a9,9,0,0,0,2.1-.8c2.6-1.4,4.2-4.4,4.6-8.3Z"
            transform="translate(-134.9 -35)"
          />
          <polygon class="cls-2" points="41.4 37 37.3 39.3 27.1 45.3 41.3 53.5 41.4 37" />
          <polygon class="cls-2" points="26.4 27.7 26.4 44 40.5 35.8 26.4 27.7" />
          <path
            class="cls-3"
            d="M201.5,96.4c4.7-2.7,7.3-8.4,7.3-16h0V52.9h0a.6.6,0,0,0-.3-.6h-.3L184.7,38.5h-.1c-6.7-3.8-13-4.5-17.8-1.7L142.2,51c-.1,0-.1.1-.2.2-4.6,2.8-7.1,8.4-7.1,15.9-.1,15.4,10.8,34.2,24.2,42a22.5,22.5,0,0,0,11.2,3.4,13.2,13.2,0,0,0,6.6-1.7l.6-.4ZM142.9,52.3a11.8,11.8,0,0,1,5.9-1.5A20.8,20.8,0,0,1,159.3,54l.6.3L183,67.6V94.7h0c0,7-2.4,12.3-6.7,14.8s-10.1,1.9-16.3-1.7c-13-7.5-23.6-25.8-23.6-40.8C136.3,59.9,138.7,54.7,142.9,52.3Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-7"
            d="M159.9,107.8c6.2,3.6,12,4.2,16.3,1.7s6.7-7.7,6.7-14.8h0V67.6L159.9,54.3l-.6-.3a20.8,20.8,0,0,0-10.5-3.2,11.5,11.5,0,0,0-5.9,1.5c-4.3,2.4-6.6,7.7-6.6,14.8C136.2,82,146.8,100.3,159.9,107.8Zm17.3-16.4a.6.6,0,0,1,.3.6c-.3,5-2.2,8.7-5.4,10.5a9.2,9.2,0,0,1-4.9,1.3,15.2,15.2,0,0,1-5.3-1.1l-1.9-.8a.6.6,0,0,1-.3-.6V82.5a.6.6,0,0,1,.3-.6.9.9,0,0,1,.7,0Zm.1-21.1a.6.6,0,0,1,.3.6V89.7a.6.6,0,0,1-.3.6h-.6l-16.3-9.5a.6.6,0,0,1-.3-.6V61.5a.6.6,0,0,1,.3-.6.9.9,0,0,1,.7,0Zm-35.4,1.1a.9.9,0,0,1,.7,0l16.3,9.4a.6.6,0,0,1,.3.6v18.8a.6.6,0,0,1-.3.6h-.6c-9-5.7-16.1-18.1-16.6-28.7C141.5,71.8,141.7,71.6,141.9,71.4Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M158.1,100.7h.6a.6.6,0,0,0,.3-.6V81.4a.6.6,0,0,0-.3-.6l-16.3-9.4a.9.9,0,0,0-.7,0,.6.6,0,0,0-.3.6C142,82.7,149.1,95,158.1,100.7Zm-.3-1.9c-5.4-3.8-10-10.1-12.6-16.8v-.2l-.6-1.6c-.1-.2-.1-.4-.2-.6a5.6,5.6,0,0,0-.4-1.2c-.1-.3-.1-.6-.2-.9a2.9,2.9,0,0,1-.2-.9c-.1-.3-.1-.7-.2-1s-.1-.5-.1-.8a3.4,3.4,0,0,1-.1-1v-.4L157.9,82Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M160.9,82h-.7a.6.6,0,0,0-.3.6v18.8a.6.6,0,0,0,.3.6l1.9.8a14.8,14.8,0,0,0,5.3,1.1,9.2,9.2,0,0,0,4.9-1.3c3.3-1.8,5.2-5.6,5.4-10.5a.6.6,0,0,0-.3-.6Zm10.6,19.4a6.6,6.6,0,0,1-2.1.8l-.9.2h-.1a13.6,13.6,0,0,1-6.3-1.1l14-8.1C175.6,97,174,100,171.5,101.4Zm-3.8-5-6.5,3.8V83.9l14,8.1Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M160.3,60.9a.6.6,0,0,0-.3.6V80.2a.6.6,0,0,0,.3.6l16.3,9.5h.6a.6.6,0,0,0,.3-.6V70.9a.6.6,0,0,0-.3-.6L161,60.9A.9.9,0,0,0,160.3,60.9ZM162,80.3l10.2-5.9,4.1-2.4V88.6Zm-.7-1.3V62.7l14,8.1Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M206.8,122.9c2.9,1.7,5.8,1.9,7.5.4s1.6-4.7,1.6-7.8V95.3l-6-3.5v21.3c0,1.6-.1,3.2-1.1,3.8a2.2,2.2,0,0,1-2.2-.2c-2-1.2-2.4-3.4-2.6-5.4l-6.6-3.9a18.7,18.7,0,0,0,5.6,12.3A18.3,18.3,0,0,0,206.8,122.9Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M243.2,125.8v-6.2l-5.2-3V118a.6.6,0,0,1-.3.6.9.9,0,0,1-.7,0h-.1l-.3-.3a15,15,0,0,0-6.1-6.9c-2.8-1.6-5.2-1.9-7-.8s-3.1,3.8-3.1,7.3c0,7.6,4.5,15.7,10.7,19.3,2,1.1,4.5,1.9,5.5.3a.7.7,0,0,1,.9-.2h.1a.6.6,0,0,1,.3.6v2.3l5.2,3Zm-8.8,7a5.7,5.7,0,0,1-2.9-.9,12.6,12.6,0,0,1-5.8-10.1c0-2.1.7-3.7,2-4.4s2.8-.6,4.5.4a12.6,12.6,0,0,1,5.9,10.2c0,2.1-.7,3.6-2,4.3A2.6,2.6,0,0,1,234.4,132.8Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M238,128a12.4,12.4,0,0,0-5.9-10.2c-1.7-1-3.3-1.1-4.5-.4s-2,2.3-2,4.4a12.6,12.6,0,0,0,5.8,10.1,5.7,5.7,0,0,0,2.9.9,2.6,2.6,0,0,0,1.7-.5C237.3,131.6,238,130.1,238,128Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M281.7,152.4c0-3.5,0-6.3-2.2-10.3a14.8,14.8,0,0,0-5.5-5.6c-1.8-1-4.3-1.8-6.1.3a.7.7,0,0,1-.6.3,1.3,1.3,0,0,1-.6-.4,14.3,14.3,0,0,0-6-7.8c-2.5-1.5-4.3-1.5-5.2-.2a1.1,1.1,0,0,1-.8.3.7.7,0,0,1-.5-.7V126l-4.7-2.7v23.6l5.2,3V137.7a12.8,12.8,0,0,1,.1-1.9,3.4,3.4,0,0,1,1.4-2.6c.8-.5,2-.3,3.3.4s3.6,4,3.6,7.8v13.3l5.2,3V145.1c0-1.5.1-3.4,1.5-4.2s1.9-.3,3.3.4c3.3,1.9,3.7,5,3.7,8.2v13l5.2,3Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M301.1,175.1c1-.6,1.6-2,1.6-3.8,0-5-3.8-8.6-6.9-11.4s-4.1-3.8-4.1-5.7a1.9,1.9,0,0,1,.7-1.5,2.2,2.2,0,0,1,2.2.2,4.6,4.6,0,0,1,2.4,3.3l4.9,2.9a16.5,16.5,0,0,0-7.9-11,8.5,8.5,0,0,0-4-1.3,3.4,3.4,0,0,0-1.8.4h-.3a4.3,4.3,0,0,0-1.5,3.6c0,2.7,1.7,5.9,5,9.1l2.9,2.8.4.4c1.2,1.3,2.7,2.8,2.7,4.7a1.7,1.7,0,0,1-.8,1.5,2.8,2.8,0,0,1-2.6-.3,5.6,5.6,0,0,1-2.8-3.9l-4.9-3a17,17,0,0,0,8.4,11.6C297.4,175.5,299.7,175.9,301.1,175.1Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M314,165.8a.6.6,0,0,1,.3-.6h.7l2.1,1.3v-4.1l-2.8-1.6a.6.6,0,0,1-.3-.6v-8l-5.2-3v7.1a.6.6,0,0,1-.3.6h-.7l-2.2-1.3v4.1l2.9,1.7a.6.6,0,0,1,.3.6v19.1l5.2,3Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M342.5,183.1v-6.2l-4.7-2.7-.5-.3v1.5a.6.6,0,0,1-.3.6h-.8l-.3-.3a15,15,0,0,0-6.1-6.9c-2.8-1.6-5.2-1.9-7-.8s-3.1,3.8-3.1,7.3c0,7.6,4.5,15.7,10.7,19.3,2,1.1,4.5,1.9,5.5.3a.7.7,0,0,1,.9-.2h.1a.6.6,0,0,1,.3.6v2.3l5.2,3Zm-11,6.6-.8-.4a12.6,12.6,0,0,1-5.8-10.1c0-2.1.7-3.7,2-4.4s2.8-.6,4.5.4a12.6,12.6,0,0,1,5.9,10.3c0,2.1-.7,3.6-2,4.3a3.1,3.1,0,0,1-1.7.4A5.4,5.4,0,0,1,331.5,189.7Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M335.3,189.7c1.3-.7,2-2.2,2-4.3a12.4,12.4,0,0,0-5.9-10.3c-1.7-1-3.3-1.1-4.5-.4s-2,2.3-2,4.4a12.6,12.6,0,0,0,5.8,10.1l.8.4a6.3,6.3,0,0,0,2.2.5A2.3,2.3,0,0,0,335.3,189.7Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M369.3,208.1l-5.7-3.3c-.8,1-2.5,2-5.3.3a11.9,11.9,0,0,1-5.6-10c0-2.2.7-3.8,2-4.5s2.2-.8,4.2.4a11.6,11.6,0,0,1,5.1,6.5l5.1,2.9c-1.5-6.2-5.8-12.3-11-15.3a9.5,9.5,0,0,0-4.8-1.5,5,5,0,0,0-2.7.7c-2,1.1-3.1,3.6-3.1,7,0,7.3,5,16,11.4,19.7,2.7,1.6,5.3,2,7.3,1.1A5.9,5.9,0,0,0,369.3,208.1Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-3"
            d="M411.1,198.1l7.3-5.6.5-.3a.6.6,0,0,0,.3-.6h0a.6.6,0,0,0-.1-.4.5.5,0,0,0-.5-.3l-7.5-4.4h-.7l-5.1,3V175a.6.6,0,0,0-.3-.6l-6.6-3.8h-.7l-7.9,4.6a24.5,24.5,0,0,0-6.4-5.7c-3.3-2-6.6-2.2-8.9-.8l-6.1,3.6v-9.8c0-.1.1-.2.1-.3a.6.6,0,0,0-.3-.6l-6.6-3.8a.9.9,0,0,0-.7,0l-.5.3a15.4,15.4,0,0,0-5.3-5c-4-2.4-6.8-1.7-8.4-.8l-6.7,3.9v-.6l2.8-1.6a.6.6,0,0,0,.3-.6v-5.7a.6.6,0,0,0-.3-.6l-2.8-1.6v-8h0a.4.4,0,0,0-.1-.3h-.1c-.1-.1-.1-.2-.2-.2h0l-6.6-3.8h-.7l-7.6,4.4a19.2,19.2,0,0,0-5.4-4.8c-2.9-1.6-5.5-1.9-7.3-.8l-4.5,2.6a17.3,17.3,0,0,0-2.3-7.4,16.7,16.7,0,0,0-6-6.1H299c-2.9-1.6-4.9-1.1-6.1-.5l-.6.4c-1.5-3.4-3.5-6-6.2-7.5s-4.4-1.7-5.9-.9v-1.2a.6.6,0,0,0-.3-.6h-.3l-5.9-3.4H273l-3.8,2.2v-4.4h0a.6.6,0,0,0-.3-.6l-6.6-3.8a.9.9,0,0,0-.7,0l-.5.3a16.5,16.5,0,0,0-5.3-5c-4-2.4-6.8-1.7-8.4-.8l-5.6,3.3V80.6h0a.6.6,0,0,0-.3-.6l-7.5-4.3a.9.9,0,0,0-.7,0L208.8,90h-.1a.6.6,0,0,0-.3.6v7.9l-12.1,7.1a.6.6,0,0,0-.3.6h0a20.1,20.1,0,0,0,6.1,14.5,17.5,17.5,0,0,0,4.1,3.2,11.8,11.8,0,0,0,5.3,1.6,6.4,6.4,0,0,0,2.8-.7h.3l5-2.9c1.2,6.8,5.4,13.3,11,16.5,2.4,1.4,4.7,1.7,6.1,1v1.3a.6.6,0,0,0,.3.6l6.6,3.8h.6l3.7-2.2v4.5a.6.6,0,0,0,.3.6l6.6,3.8a.9.9,0,0,0,.7,0l.3-.3,5.8-3.4v7.1a.6.6,0,0,0,.3.6l6.6,3.8h.7l.2-.2,5.8-3.4v6.9a.6.6,0,0,0,.3.6l6.6,3.8h.3c.1,0,.3,0,.2.2l.3-.4,3.1-1.8a18.7,18.7,0,0,0,8.3,9.7,10.9,10.9,0,0,0,5.2,1.7,6.2,6.2,0,0,0,2.6-.6,1,1,0,0,0,.5-.4l4.9-2.8v8.5a.6.6,0,0,0,.3.6l6.6,3.8h.6l4.7-2.8a23.9,23.9,0,0,0,10,12.6c2.4,1.4,4.7,1.7,6.1,1v1.3a.6.6,0,0,0,.3.6l6.6,3.8h.7l4.5-2.7c2.1,5.1,5.9,9.9,10.2,12.4a11.2,11.2,0,0,0,5.7,1.7,6.2,6.2,0,0,0,2.9-.7h.7l5.3-3.1V219a.6.6,0,0,0,.3.6l6.6,3.8h.7l3.3-1.9,2,5.2c.1.1.1.3.3.3l7.5,4.3h.9L418.6,217a.8.8,0,0,0,.3-.9Zm-30.3,12.6c-.1-.1-.1-.3-.3-.3h-.1a.9.9,0,0,0-.7,0,.6.6,0,0,0-.3.6v11l-5.2-3V186.8l5.2,3V207a.6.6,0,0,0,.3.6h.1a.8.8,0,0,0,.8-.1l5.7-5.3,6.4,3.7-7.5,5.7a.8.8,0,0,0-.2.8l7.2,16.9-5.4-3.1Zm-21.9.2c-6.4-3.7-11.4-12.3-11.4-19.7,0-3.3,1.1-5.9,3.1-7a5,5,0,0,1,2.7-.7,9.5,9.5,0,0,1,4.8,1.5c5.2,3,9.5,9.1,11,15.3l-5.1-2.9a11.6,11.6,0,0,0-5.1-6.5c-2-1.2-3.4-.9-4.2-.4s-2,2.3-2,4.5a11.8,11.8,0,0,0,5.6,10c2.8,1.7,4.5.8,5.3-.3l5.7,3.3a6.2,6.2,0,0,1-3.1,4C364.2,212.9,361.7,212.5,358.9,210.9Zm-21.6-15.6a.6.6,0,0,0-.3-.6h-.1a.7.7,0,0,0-.9.2c-1,1.5-3.6.8-5.5-.3-6.2-3.6-10.7-11.6-10.7-19.3,0-3.6,1.1-6.2,3.1-7.3s4.2-.8,7,.8a14.4,14.4,0,0,1,6.1,6.9c.1.1.1.3.3.3h.8a.6.6,0,0,0,.3-.6V174l.5.3,4.7,2.7v23.7l-5.2-3ZM308.9,162a.6.6,0,0,0-.3-.6l-2.9-1.7v-4.1l2.2,1.3h.7a.6.6,0,0,0,.3-.6v-7.1l5.2,3v8a.6.6,0,0,0,.3.6l2.8,1.6v4.1l-2.1-1.3h-.7a.6.6,0,0,0-.3.6v18.3l-5.2-3Zm-14.1,12a17.8,17.8,0,0,1-8.4-11.6l4.9,3a5.6,5.6,0,0,0,2.8,3.9,2.8,2.8,0,0,0,2.6.3,1.7,1.7,0,0,0,.8-1.5c0-1.9-1.5-3.4-2.7-4.7l-.4-.4-2.9-2.8c-3.3-3.3-5-6.4-5-9.1a4.3,4.3,0,0,1,1.5-3.6h.3a3.4,3.4,0,0,1,1.8-.4,8.5,8.5,0,0,1,4,1.3,16.3,16.3,0,0,1,7.9,11l-4.9-2.9a4.5,4.5,0,0,0-2.4-3.3,2,2,0,0,0-2.2-.2,1.9,1.9,0,0,0-.7,1.5c0,1.9,1.8,3.6,4.1,5.7s6.9,6.3,6.9,11.4c0,1.9-.6,3.2-1.6,3.8S297.4,175.5,294.8,174Zm-18.2-24.4c0-3.1-.4-6.3-3.7-8.2-1.4-.8-2.4-.9-3.3-.4s-1.5,2.7-1.5,4.2v12.6l-5.2-3V141.5q0-5.7-3.6-7.8a3.2,3.2,0,0,0-3.3-.4,3.1,3.1,0,0,0-1.4,2.6,12.1,12.1,0,0,0-.1,1.9V150l-5.2-3V123.4l4.7,2.7v2.3a.8.8,0,0,0,.5.7.8.8,0,0,0,.8-.3c1-1.3,2.7-1.3,5.2.2a14.7,14.7,0,0,1,6,7.8.9.9,0,0,0,.6.4.7.7,0,0,0,.6-.3c1.7-2.2,4.3-1.4,6.1-.3a14.8,14.8,0,0,1,5.5,5.6c2.2,4,2.2,6.8,2.2,10.3v13.1l-5.2-3ZM238,138a.6.6,0,0,0-.3-.6h-.1a.7.7,0,0,0-.9.2c-1,1.5-3.6.8-5.5-.3-6.2-3.6-10.7-11.6-10.7-19.3,0-3.6,1.1-6.2,3.1-7.3s4.2-.8,7,.8a14.4,14.4,0,0,1,6.1,6.9c.1.1.1.3.3.3h.8a.6.6,0,0,0,.3-.6v-1.4l5.2,3v23.7l-5.2-3V138Zm-40.7-30.4,6.6,3.9c.1,2,.6,4.2,2.6,5.4a2,2,0,0,0,2.2.2c1-.6,1.1-2.2,1.1-3.8V92l6,3.5v19.9a.4.4,0,0,0,.1.3c0,3,0,6.4-1.6,7.8s-4.5,1.3-7.5-.4a20.8,20.8,0,0,1-3.8-3A20,20,0,0,1,197.3,107.6Z"
            transform="translate(-134.9 -35)"
          />
          <path
            class="cls-2"
            d="M386.8,226.2l5.4,3.1L385,212.4a.8.8,0,0,1,.2-.8l7.5-5.7-6.4-3.7-5.7,5.3a.8.8,0,0,1-.8.1h-.1a.6.6,0,0,1-.3-.6V189.7l-5.2-3v32.1l5.2,3v-11a.6.6,0,0,1,.3-.6h.8l.3.3Z"
            transform="translate(-134.9 -35)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    jamstackAnim() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-jamstack1",
            toggleActions: this.toggleConfig,
            start: "center bottom",
          },
          defaults: {
            duration: 1,
            ease: "sine",
          },
        })
        .add("jamstack1")
        .from(
          "#man-arm",
          {
            rotation: -70,
            repeat: 2,
            yoyo: true,
            transformOrigin: "100% 100%",
          },
          "jamstack1"
        )
        .from(
          "#woman-arm",
          {
            rotation: 40,
            repeat: 2,
            yoyo: true,
            transformOrigin: "100% 0%",
          },
          "jamstack1+=0.5"
        )
        .from(
          "#clip-jamstackconf1",
          {
            x: 100,
            y: -100,
          },
          "jamstack1"
        );
    },
  },
  mounted() {
    this.jamstackAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
}

.cls-2 {
  fill: #fff;
}

.cls-3 {
  fill: #0e1e25;
}

.cls-4 {
  fill: #8e6f46;
}

.cls-5 {
  fill: #cc801f;
}

.cls-6 {
  clip-path: url(#jamstack-clip);
}

.cls-7 {
  fill: #ffad43;
}
</style>